// @unocss-include
const routes = [
  {
    path: '/share',
    component: () => import('@/views/Share/Index.vue'),
    name: 'Share',
    meta: {
      roles: [1]
    }
  }
]
export default routes
